/******/ (() => {
  window.PXUTheme.jsFeaturedProductsHero = {
    init: function($section) {
      $section = $section instanceof jQuery ? $section : $($section);

      const sectionData = window.PXUTheme.getSectionData($section);

      this.createSlider($section, sectionData);
    },

    createSlider: function($section, sectionData) {
      const $slider = $section.find('.featured-products-hero__slider');

      if (!$slider.length) return;

      /*
       * Prevent duplicate initialization when Shopify reloads
       * the section inside the Theme Editor.
       */
      if ($slider.hasClass('flickity-enabled')) {
        $slider.flickity('destroy');
      }

      const productsAvailable =
        parseInt($slider.attr('data-products-available'), 10) || 0;

      const hasMultipleProducts = productsAvailable > 1;

      const showArrows =
        sectionData.show_arrows === true && hasMultipleProducts;

      const showDots =
        sectionData.show_dots === true && hasMultipleProducts;

      const wrapAround =
        sectionData.wrap_around === true && hasMultipleProducts;

      const flickityOptions = {
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: hasMultipleProducts,

        /*
         * Centering the active product allows the previous and next
         * products to remain visible at the viewport edges.
         */
        cellAlign: 'center',
        contain: false,

        /*
         * Move one product at a time instead of using a free-moving strip.
         */
        freeScroll: false,
        groupCells: false,

        wrapAround: wrapAround,
        pageDots: showDots,
        prevNextButtons: showArrows,

        initialIndex: 0,
        adaptiveHeight: false,
        setGallerySize: true,

        on: {
          ready: function() {
            const flickityInstance = this;

            window.requestAnimationFrame(function() {
              flickityInstance.resize();
            });
          },

          settle: function() {
            this.resize();
          }
        }
      };

      /*
       * Reuse the theme's existing arrow design when that global
       * variable is available.
       */
      if (typeof arrowShape !== 'undefined') {
        flickityOptions.arrowShape = arrowShape;
      }

      $slider.flickity(flickityOptions);
    },

    unload: function($section) {
      $section = $section instanceof jQuery ? $section : $($section);

      const $slider = $section.find(
        '.featured-products-hero__slider.flickity-enabled'
      );

      if ($slider.length) {
        $slider.flickity('destroy');
      }
    }
  };
})();